var form, query, submit, preview, timer;
var initialQuery = 'vesselId=9&dateTime=2022-12-12T09:17:45.913Z&zoom=7&height=500&width=450&token=1t5Me';
/**/
(function run() {
    form = document.getElementById('form');
    query = document.getElementById('query');
    submit = document.getElementById('submit');
    preview = document.getElementById('preview');
    query.value = initialQuery;
    form.addEventListener('submit', onSubmit);
    submit.addEventListener('click', onSubmit);
}());
/**/
function onSubmit(e) {
    var path = "/api/image?".concat(query.value);
    var url = location.host.startsWith('localhost')
        ? 'http://localhost:3440' + path
        : path;
    console.log('Request URL: ', url);
    e.preventDefault();
    onLoading();
    fetch(url)
        .then(function (resp) {
        // if (!resp.ok) {
        //   throw new Error(`${resp.status}:: ${resp.statusText}`);
        // }
        return resp.text();
    })
        .then(onOk)
        .catch(onError);
}
/**/
function onLoading() {
    preview.innerText = '. . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .';
    timer = setInterval(function () {
        preview.innerHTML = "<code>".concat(Math.random().toString(36).substring(2), "</code>");
    }, 400);
}
/**/
function onOk(data) {
    if (data.includes('message'))
        return onError({ message: data });
    clearInterval(timer);
    console.log('Response data: ', data);
    preview.innerHTML = "<img alt=\"Screenshot\" src=\"".concat(data, "\" />");
    var img = new Image();
    img.src = data;
    img.onload = function () {
        preview.innerHTML += "<p>".concat(img.width, "x").concat(img.height, "</p>");
        preview.innerHTML += "<p>".concat(img.src, "</p>");
    };
}
/**/
function onError(e) {
    console.error(e);
    clearInterval(timer);
    preview.innerHTML = "\n    <div class=\"error\">\n      <code>".concat(e.message, "</code>\n    </div>\n  ");
}
export {};
